var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBooks(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19354_5345)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.19015 9.40187H9.20927C9.26699 9.41161 9.32472 9.41161 9.39182 9.41161H9.4398C9.5069 9.41161 9.574 9.42099 9.65084 9.42099L41.798 9.36363L41.3853 9.02777C40.2915 8.13525 39.61 6.85889 39.4567 5.43858L39.4372 5.26577L12.1361 5.31375C11.8962 5.31375 11.6949 5.11246 11.6949 4.87256C11.6949 4.75748 11.7429 4.64202 11.8197 4.55581C11.9059 4.46959 12.0116 4.42161 12.1267 4.42161L39.4372 4.37363L39.4567 4.20082C39.61 2.81875 40.2723 1.57125 41.3182 0.669362L41.7118 0.333496H9.66059C7.16558 0.343242 5.15039 2.38692 5.15039 4.89167C5.15039 6.11031 5.62045 7.25248 6.47436 8.10639C7.21357 8.85496 8.15369 9.30591 9.19015 9.40187Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5348 10.2461L17.9321 10.2941L11.7715 10.3034V48.314L43.5348 48.2563V10.2461ZM19.6115 21.4639C19.6115 21.224 19.8034 21.0227 20.0527 21.0227L36.1457 20.9938C36.2608 20.9938 36.3759 21.0418 36.4527 21.1186C36.539 21.2048 36.5776 21.3105 36.5776 21.435V27.1353C36.5776 27.3752 36.3856 27.5765 36.136 27.5765L20.0433 27.6054C19.9282 27.6054 19.8128 27.5574 19.7363 27.4806C19.6497 27.3944 19.6115 27.2887 19.6115 27.1642V21.4639Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.64099 10.3133C9.55478 10.3133 9.45881 10.3133 9.36285 10.3035H9.31487C9.23803 10.3035 9.16118 10.2942 9.09409 10.2844C9.07497 10.2844 9.0461 10.2751 9.02699 10.2751L8.95014 10.2653C8.91191 10.2653 8.8733 10.2556 8.83506 10.2462C7.65466 10.0734 6.53198 9.52648 5.67808 8.71081L5.36133 8.40381V44.2166C5.36133 45.3202 5.78341 46.3566 6.56085 47.1337C7.32854 47.9014 8.34551 48.3332 9.4397 48.3332H10.812V10.323L9.64099 10.3133Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19354_5345"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0.333984 0.333496)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBooks);
export default __webpack_public_path__ + "static/media/books.0b25b4a1f4ab92092e8ac0ae0843fb6a.svg";
export { ForwardRef as ReactComponent };